import { Editor } from '@tinymce/tinymce-react'
import React, { useEffect, useRef, useState } from 'react'
import { TbCameraUp } from 'react-icons/tb'
import { Link, useNavigate, useParams } from 'react-router-dom'
import useSponsorsActions from '../hooks/useSponsorsActions'
import {
  getRefFile,
  getRefValue,
  showToastError,
  showToastSuccess,
} from '../../../helper'
import editorConfig from '../../../config/editorConfig'
import { useSponsorContext } from '../context/sponsor/SponsorProvider'
import useCountries from '../../core/hooks/useCountries'
import usePackages from '../../core/components/UI/hooks/usePackages'
import Breadcrumb from '../../core/components/UI/Breadcrumb'
import FormUpdateSponsor from '../components/sponsors-update-page/FormUpdateSponsor'
import LoadingFormUpdateSponsor from '../components/sponsors-update-page/LoadingFormUpdateSponsor'

export default function SponsorEditPage() {
  const { sponsor_id } = useParams()
  const { sponsorState } = useSponsorContext()
  const { getSponsor } = useSponsorsActions()

  useEffect(() => {
    getSponsor(sponsor_id)
  }, [sponsor_id])

  const links = [
    {
      id: 1,
      label: 'الرعاة',
      isActive: false,
      to: '/sponsors',
    },
    {
      id: 2,
      label: sponsorState.sponsor?.name_ar,
      isActive: true,
      to: `/sponsor/${sponsor_id}/update`,
    },
    {
      id: 3,
      label: ' / تعديل',
      isActive: true,
    },
  ]
  return (
    <>
      <Breadcrumb links={links} />
      <div className="border-2 border-muted-500 bg-white p-2">
        {sponsorState.isLoading ? (
          <LoadingFormUpdateSponsor />
        ) : (
          <FormUpdateSponsor
            sponsorId={sponsor_id}
            sponsor={sponsorState.sponsor}
          />
        )}
      </div>
    </>
  )
}
